(function () {
  var LANGS = ['NO', 'EN', 'ES'];

  function buildSelector() {
    var rightCol = document.querySelector('.header__column--right');
    if (!rightCol) return false;
    if (document.getElementById('kaay-lang-selector')) return true;

    var actions = rightCol.querySelector('header-actions');
    var current = localStorage.getItem('kaay-lang') || 'NO';

    var el = document.createElement('div');
    el.className = 'kaay-lang-selector';
    el.id = 'kaay-lang-selector';
    el.innerHTML =
      '<button class="kaay-lang-selector__btn" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="kaay-lang-selector__label">' + current + '</span>' +
        '<svg width="9" height="5" viewBox="0 0 9 5" fill="none" aria-hidden="true">' +
          '<path d="M1 1l3.5 3L8 1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>' +
      '<ul class="kaay-lang-selector__dropdown" role="listbox">' +
        LANGS.map(function (l) {
          return '<li class="kaay-lang-selector__option' + (l === current ? ' is-active' : '') +
            '" data-lang="' + l + '" role="option" tabindex="0">' + l + '</li>';
        }).join('') +
      '</ul>';

    if (actions) {
      rightCol.insertBefore(el, actions);
    } else {
      rightCol.appendChild(el);
    }

    var btn      = el.querySelector('.kaay-lang-selector__btn');
    var dropdown = el.querySelector('.kaay-lang-selector__dropdown');
    var label    = el.querySelector('.kaay-lang-selector__label');

    function close() {
      btn.setAttribute('aria-expanded', 'false');
      dropdown.classList.remove('is-open');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.contains('is-open') ? close() : (btn.setAttribute('aria-expanded', 'true'), dropdown.classList.add('is-open'));
    });

    el.querySelectorAll('.kaay-lang-selector__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var lang = this.dataset.lang;
        label.textContent = lang;
        localStorage.setItem('kaay-lang', lang);
        el.querySelectorAll('.kaay-lang-selector__option').forEach(function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        close();
      });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
      });
    });

    document.addEventListener('click', close);
    return true;
  }

  function waitForHeader() {
    if (buildSelector()) return;

    // Fabric renders header asynchronously — observe DOM until the column appears
    var observer = new MutationObserver(function () {
      if (buildSelector()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety fallback: stop observing after 10 seconds
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForHeader);
  } else {
    waitForHeader();
  }
})();
